const getExpressHeaders = (required = false) => {
  const token = sessionStorage.getItem("tokenf");
  const licenseeCode = sessionStorage.getItem("LicenseeCode");
  const CompanyCode = sessionStorage.getItem("CompanyCode");
  const BranchCode = sessionStorage.getItem("BranchCode");
  console.log(sessionStorage.getItem("SelectedFromDate"));
  const From_Date = sessionStorage.getItem("SelectedFromDate")
    ? JSON.parse(sessionStorage.getItem("SelectedFromDate"))
    : "";
  const To_Date = sessionStorage.getItem("SelectedFromDate")
    ? JSON.parse(sessionStorage.getItem("SelectedToDate"))
    : "";
  const DateData = JSON.parse(sessionStorage.getItem("SelectedFinancialYear"));
  const path = window.location.pathname;
  //If required passing true that means it is from customer side
  return required
    ? { authorization: token ? `${token}` : "", usertype: "erp" }
    : {
        authorization: token ? `${token}` : "",
        requestUrl: path,
        usertype: "erp",
        tenantIds: licenseeCode,
        CompanyCode,
        BranchCode,
        FromDate: From_Date,
        ToDate: To_Date,
        FinancialYearFromDate: DateData?.fromDate,
        FinancialYearToDate: DateData?.toDate,
      };
};

export default getExpressHeaders;
